/* FLORA CUSTOMIZATION — smooth desktop slider mouse drag */
(() => {
  let activeSlider = null;
  let blockedSlider = null;
  let pointerId = null;
  let startX = 0;
  let startScrollLeft = 0;
  let targetScrollLeft = 0;
  let currentScrollLeft = 0;
  let moved = false;
  let animationFrame = null;

  const isControl = (element) =>
    element.closest(
      'button, input, select, textarea, [contenteditable="true"]'
    );

  const animateDrag = () => {
    if (!activeSlider || !moved) {
      animationFrame = null;
      return;
    }

    currentScrollLeft +=
      (targetScrollLeft - currentScrollLeft) * 0.45;

    activeSlider.scrollLeft = currentScrollLeft;

    if (Math.abs(targetScrollLeft - currentScrollLeft) > 0.5) {
      animationFrame = requestAnimationFrame(animateDrag);
    } else {
      activeSlider.scrollLeft = targetScrollLeft;
      currentScrollLeft = targetScrollLeft;
      animationFrame = null;
    }
  };

  const endDrag = (event) => {
    if (!activeSlider || event.pointerId !== pointerId) return;

    const releasedSlider = activeSlider;

    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    if (releasedSlider.hasPointerCapture(pointerId)) {
      releasedSlider.releasePointerCapture(pointerId);
    }

    releasedSlider.classList.remove('is-mouse-dragging');

    if (moved) {
      blockedSlider = releasedSlider;

      if (releasedSlider.itemOffset > 0) {
        const nearestPosition =
          Math.round(
            targetScrollLeft / releasedSlider.itemOffset
          ) * releasedSlider.itemOffset;

        releasedSlider.scrollToPosition(nearestPosition);
      }

      setTimeout(() => {
        blockedSlider = null;
      }, 0);
    }

    activeSlider = null;
    pointerId = null;
    moved = false;
  };

document.addEventListener('pointerdown', (event) => {
  const isDesktop = window.matchMedia(
    '(min-width: 1024px) and (hover: hover) and (pointer: fine)'
  ).matches;

  if (
    !isDesktop ||
    event.pointerType !== 'mouse' ||
    event.button !== 0
  ) return;

    const slider = event.target.closest(
      'slider-element[tabindex="0"]'
    );

    if (!slider || isControl(event.target)) return;

    activeSlider = slider;
    pointerId = event.pointerId;
    startX = event.clientX;
    startScrollLeft = slider.scrollLeft;
    targetScrollLeft = slider.scrollLeft;
    currentScrollLeft = slider.scrollLeft;
    moved = false;
  });

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!activeSlider || event.pointerId !== pointerId) return;

      const distance = event.clientX - startX;

      if (!moved && Math.abs(distance) < 5) return;

      if (!moved) {
        moved = true;
        activeSlider.setPointerCapture(pointerId);
        activeSlider.classList.add('is-mouse-dragging');
      }

      event.preventDefault();
      targetScrollLeft = startScrollLeft - distance;

      if (!animationFrame) {
        animationFrame = requestAnimationFrame(animateDrag);
      }
    },
    { passive: false }
  );

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('dragstart', (event) => {
    if (activeSlider?.contains(event.target)) {
      event.preventDefault();
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      if (
        blockedSlider &&
        (event.target === blockedSlider ||
          blockedSlider.contains(event.target))
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();